import { render, staticRenderFns } from "./NewBusiness.vue?vue&type=template&id=493cec39&"
import script from "./NewBusiness.vue?vue&type=script&lang=js&"
export * from "./NewBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports